import React, {useCallback, useMemo, useState} from 'react';
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
import ftpUserService from "../../../../services/web/ftp-user-service.js";

const initialFilters = {username: ""};

const buildFilter = (values) => [
    {field: "username", type: "like", value: (values.username ?? "").replaceAll("'", "")},
];

const FtpUserList = () => {
    const navigate = navigateHook();

    const [filterValues, setFilterValues] = useState(initialFilters);
    const [filter, setFilter] = useState([]);

    const {data = [], isLoading} = useQuery({
        queryFn: () => ftpUserService.list({filter: [...filter], sort: [{field: "username", dir: "asc"}], page: 1, size: 99999}),
        queryKey: ["ftp-users", {filter}],
        placeholderData: keepPreviousData,
    });

    const [columnDefs,] = useState([
        { field: "username", headerName: "Usuário", sort: "asc", flex: 1, comparator: aggridUtils.nullLastComparator},
        { field: "lanes", headerName: "Câmeras", flex: 1, comparator: aggridUtils.nullLastComparator},
    ]);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const apply = useCallback(() => setFilter(buildFilter(filterValues)), [filterValues]);

    const clear = useCallback(() => {
        setFilterValues(initialFilters);
        setFilter([]);
    }, []);

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data}) => {
        navigate(`/ftp-users/form/${data.id}`);
    };

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Usuários FTP</Template.Title>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"username"}
                                label={"Usuário"}
                                name={"username"}
                                value={filterValues.username}
                                onChange={({target: {value}}) => setFilterValues(prev => ({...prev, username: value}))}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"aggrid-row-pointer h-[calc(100vh-153px)]"}>
                            <AgGridReact
                                rowData={data}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                                onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default FtpUserList;
